import { createClient, type Client } from '../generated/client';

export type PsetRegionEndpointConfig = {
  [key in 'pset-api']: string;
};

export interface CreatePsetServiceClientOptions {
  region: PsetRegionEndpointConfig;
}

export const getRegionalPsetBaseUrl = (
  region: Pick<PsetRegionEndpointConfig, 'pset-api'>
): string => {
  const baseUrl = region['pset-api'];
  if (!baseUrl) {
    throw new Error('PSet API base URL is required.');
  }

  return baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
};

/**
 * Creates a PSet API client configured for a selected Connect region.
 * Authentication is provided by the consumer via client config.
 */
export function createPsetServiceClient(
  options: CreatePsetServiceClientOptions
): Client {
  return createClient({
    baseUrl: getRegionalPsetBaseUrl(options.region),
  });
}
